import React from 'react';
import { useState,useEffect } from 'react';
import { Route, useNavigate, Link, redirect,prop } from "react-router-dom";
import { withRouter } from "react-router-dom";
import axios from 'axios';
import Produit from './produit';
import Sidebar from './component/Sidebar';
import AdminUserBadge from './component/AdminUserBadge';
import { useHistory } from 'react-router-dom';
import {browserHistory} from "react-router";

//var avigation = require('react-router-dom').Navigation;

//var navigate = require('react-router-dom').useNavigate();
function Categorie(){

    // navigate = Navigate();
     //navigate("/produit");
     const [datacontentcategorie,setdatacontentcategorie] = useState([]);
     const [selectedFile,setselectedFile] = useState([]);
     const [responseArray,setresponseArray] = useState([]);
     const [nomproduit,setnomproduit] = useState("");
     const [categorie,setcategorie] = useState("");
     const [prix,setprix] = useState("");
     const [stock,setstock] = useState("");
     const [nomfournisseur,setnomfournisseur] = useState("");
     const [reload,setreload] = useState(true);
    const navigate = useNavigate();
    const suppression = async(idcategorie)=>{
      var urlsup= "https://jojomarket.ne/adminfood/categorie.php?supprimer&idcategorie="+idcategorie;
      const responsemodif = await axios.get(urlsup);
     // document.getElementById(idproduit).innerText = stock;
  setreload(!reload);
 // navigate('/');
    // navigate('/');
     //this.Tableproduit(props);
    }
    function handleInputChange(event){

    setselectedFile(event.target.files);
    setresponseArray([]);
    // this.setState({
    //   selectedFile: event.target.files,
    //   responseArray:[],
      

    // });
  
  };
function savecategorie(){
  if (!selectedFile) {
    alert("Ajouter une icone svp!");
    return false;
  }
  const data = new FormData();

  for (let i = 0; i < selectedFile.length; i++) {
    data.append("file[]", selectedFile[i]);
  }
  
  //data.append("idcategorieparent", nomproduit);
    data.append("nomcategorie", categorie);

    let url = "https://jojomarket.ne/adminfood/categorie.php?addcategorie";
   
   
    axios
      .post(url, data, {
        // receive two parameter endpoint url ,form data
      })
      .then((res) => {

setreload(!reload);
        console.log(res.data);
        // then print response status
        //this.setState({ responseArray: res.data });
       // setresponseArray(res.data);
       // resetFile();
        //navigate('/produit');
     //alert('super');
       // this.push = () => {
        //this.props.router.push('/produit');
       //   };

       //this.state.redirect && <Navigate to='/produit' replace={true}/>
    //this.state.history.push("/produit");
    
       //this.window.location('/produit');
      },error=>{
        alert(error);
      });
     
  }

  
  function onSubmit() { 
  
    if (!selectedFile) {
      alert("Please select a file!");
      return false;
    }
    const data = new FormData();

    for (let i = 0; i < selectedFile.length; i++) {
      data.append("file[]", selectedFile[i]);
    }
   
    data.append("nomproduit", nomproduit);
    data.append("categorie", categorie);
    data.append("prix", prix);
    data.append("stock", stock);
    data.append("nomfournisseur", nomfournisseur);
    //data.append("prix", this.state.prix);
    let url = "https://jojomarket.ne/adminfood/uploadfichier.php?idproduit=13";
   
   
    axios
      .post(url, data, {
        // receive two parameter endpoint url ,form data
      })
      .then((res) => {
        // then print response status
        //this.setState({ responseArray: res.data });
       // setresponseArray(res.data);
       // resetFile();
        navigate('/produit');
     //alert('super');
       // this.push = () => {
        //this.props.router.push('/produit');
       //   };

       //this.state.redirect && <Navigate to='/produit' replace={true}/>
    //this.state.history.push("/produit");
    
       //this.window.location('/produit');
      },error=>{
        alert(error);
      });
     
  }
 
  
 var urllistecategorie = "https://jojomarket.ne/adminfood/categorie.php?listecategorie";

  useEffect(()=>{
    
    loadContent(urllistecategorie);
  }, [reload]);



  const loadContent = async(url)=>{
    const response = await axios.get(url);

    console.log(response.data);
    setdatacontentcategorie(response.data);
  
  }



const functionmodifier = async(idcategorie,nouvellevaleur)=>{
  var urlencaisse= "https://jojomarket.ne/adminfood/categorie.php?modifier&idcategorie="+idcategorie+"&valeur="+nouvellevaleur;
  const responsemodif = await axios.get(urlencaisse);
  //document.getElementById(i).innerText = stock;
  loadContent(urllistecategorie);
}

  return (
    <div>
     <div><Sidebar/></div>
  <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg " style={{marginLeft: "260px"}}>
    {/* Navbar */}
  
  {/* Navbar */}
  <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
      <div className="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
            <li className="breadcrumb-item text-sm"><a className="opacity-5 text-dark" href="javascript:;">Accueil</a></li>
            <li className="breadcrumb-item text-sm text-dark active" aria-current="page">Categorie</li>
          </ol>
          <h6 className="font-weight-bolder mb-0">Gestion Categorie</h6>
        </nav>
        <div className="collapse justify-content-end navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
          <ul className="navbar-nav justify-content-end align-items-center">
            <li className="nav-item d-flex align-items-center">
              <a className="btn btn-outline-primary btn-sm mb-0 me-3" data-bs-toggle="modal" data-bs-target={'#ajoutercategorie'}>+ Ajouter une categorie</a>
            </li>
            <AdminUserBadge className="me-3" />
            <li className="nav-item d-flex align-items-center">
              <Link to="/login" className="nav-link text-body font-weight-bold px-0">
                <i className="fa fa-user me-sm-1" />
                <span className="d-sm-inline d-none">Deconnexion</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    {/* End Navbar */}
    <div className="container-fluid py-4">
      <div className="row">
      <div className="modal fade" id={'ajoutercategorie'} tabindex="-1" role="dialog" aria-labelledby="modal-notification" aria-hidden="true">
      <div className="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-notification">Nouvelle Categorie</h6>
            <button type="button" className="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="py-3 text-center">
              
              <h4 className=" mt-4"><input type="text" value={categorie} 
              
              onChange={(e)=>{
                setcategorie(e.target.value)
              }}
              
              
              /></h4>
              <p></p>
            </div>
            <div class="mb-3">
                    <input  type="file"
      multiple
        name="file"
onChange={handleInputChange} class="form-control"  aria-label="Password" aria-describedby="password-addon"/>
                  </div>
                 
          </div>
          <div className="modal-footer">
            <button type="button" onClick={()=>{savecategorie()}} data-bs-dismiss="modal" className="btn btn-white">Enregistrer</button>
            <button type="button" className="btn btn-link text-black ml-auto" data-bs-dismiss="modal">Annuler</button>
          </div>
        </div>
      </div>
    </div>
        
    <div class="ms-md-auto pe-md-6 d-flex align-items-center"><div class="input-group">
           <span class="input-group-text text-body"><i class="fas fa-search" aria-hidden="true"></i></span>
          </div></div>
     <table className="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID categorie</th>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Icom</th>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Categorie</th>
                      <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Sous Categorie</th>
                      <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Supprimer</th>
                     
                      <th className="text-secondary opacity-7" />
                    </tr>
                  </thead>
                  <tbody>
                  {datacontentcategorie && datacontentcategorie.map((item,index) => (
                
                    <tr key={item.idcategorie}> 
                      <td>
                      {item.idcategorie}
                      </td>
                      <td>
                      <img style={{widht:50,height:50}} src={"https://jojomarket.ne/adminfood/categorieicon/"+item.idcategorie+"-0.png"}/>
                      </td>


                      <td>
                        <p className="text-xs font-weight-bold mb-1">{item.nomcategorie}</p>
                      </td>


                      <Link  to="/souscategorie" state={{ idcategorie: item.idcategorie, nomcategorie: item.nomcategorie }} >
                      <td>
                        <p className="text-xs font-weight-bold mb-1">+ {item.souscategorie}</p>
                      </td>
                      </Link>
                      <td>
                      <a className="dropdown-item border-radius-md"  data-bs-toggle="modal" data-bs-target={'#supprimer' + item.idcategorie}> <p className="text-xs font-weight-bold mb-1"> Supprimer</p></a>
                      <a className="dropdown-item border-radius-md"  data-bs-toggle="modal" data-bs-target={'#modifier' + item.idcategorie}> <p className="text-xs font-weight-bold mb-1"> Modifier</p></a>
                      
                      <div class="modal fade" id={'supprimer' + item.idcategorie}  role="dialog" aria-labelledby="modal-notification" aria-hidden="true">
      <div class="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="modal-title-notification">Attention</h6>
            <button type="button" class="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="py-3 text-center">
              <i class="ni ni-bell-55 ni-3x"></i>
              <h4 class="mt-4">Voullez vous supprimer cette categorie!</h4>
              <p>{item.nomproduit}</p>
            </div>
          </div>
          <div class="modal-footer">
          
           <Link to="/categorie"> <button type="button" onClick={() => suppression(item.idcategorie)}  data-bs-dismiss="modal" class="btn btn-white">Oui</button></Link>
            <button type="button" class="btn btn-link text-black ml-auto" data-bs-dismiss="modal">Annuler</button>
          </div>
        </div>
      </div>
    </div>
                      <div class="modal fade" id={'modifier' + item.idcategorie}  role="dialog" aria-labelledby="modal-notification" aria-hidden="true">
      <div class="modal-dialog modal-danger modal-dialog-centered modal-" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title" id="modal-title-notification">Modification</h6>
            <button type="button" class="btn-close text-dark" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="py-3 text-center">
              <i class="ni ni-bell-55 ni-3x"></i>
              <h4 class="mt-4">{item.nomcategorie}</h4>
              <p> <input type="text" className="form-control"  onChange={(e) => functionmodifier(item.idcategorie,e.target.value)} placeholder="" aria-label="Email" aria-describedby="email-addon" />
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link text-black ml-auto" data-bs-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
                      </td>
                      </tr>

                      
    ))}
    </tbody>
    </table>
        
      </div>
    </div>

    <footer className="footer pt-3  ">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-lg-between">
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="copyright text-center text-sm text-muted text-lg-start">
                © SEFIR.
              </div>
            </div>
        
          </div>
        </div>
      </footer>
    </main>
    </div>
    
  )

            }


export default Categorie